import { FC } from "react";
import { Card, Group, SimpleGrid, Text, ThemeIcon } from "@mantine/core";
import {
  IconTournament,
  IconShirtSport,
  IconUser,
  IconClock,
  IconChairDirector,
  IconCast,
  IconMicrophone,
  IconCommand,
  IconStackFront,
  IconMoneybag,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { Page } from "../../../Components/Page";

interface QuickLinkProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  color: string;
  to: string;
}

const QuickLink: FC<QuickLinkProps> = ({
  title,
  description,
  icon,
  color,
  to,
}) => (
  <Card
    component={Link}
    to={to}
    p="lg"
    shadow="sm"
    style={{
      textDecoration: "none",
      transition: "transform 150ms ease, box-shadow 150ms ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "none";
      e.currentTarget.style.boxShadow = "";
    }}
  >
    <Group>
      <ThemeIcon color={color} size="xl" radius="md" variant="light">
        {icon}
      </ThemeIcon>
      <div>
        <Text fw={600}>{title}</Text>
        <Text size="sm" c="dimmed">
          {description}
        </Text>
      </div>
    </Group>
  </Card>
);

export const Dashboard: FC = () => {
  return (
    <Page title="Dashboard">
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }}>
        <QuickLink
          title="Turniere"
          description="Wettbewerbe verwalten"
          icon={<IconTournament size={24} />}
          color="fwcBlue"
          to="competitions"
        />
        <QuickLink
          title="Mannschaften"
          description="Teams verwalten"
          icon={<IconShirtSport size={24} />}
          color="yellow"
          to="teams"
        />
        <QuickLink
          title="Spieler"
          description="Spieler verwalten"
          icon={<IconUser size={24} />}
          color="red"
          to="players"
        />
        <QuickLink
          title="Zeitnehmer"
          description="Spielzeit und Tore"
          icon={<IconClock size={24} />}
          color="cyan"
          to="timekeeper"
        />
        <QuickLink
          title="Regie"
          description="Spiele freigeben"
          icon={<IconChairDirector size={24} />}
          color="pink"
          to="regie"
        />
        <QuickLink
          title="Ledwall"
          description="LED-Anzeige steuern"
          icon={<IconCast size={24} />}
          color="lime"
          to="ledwall"
        />
        <QuickLink
          title="Kommentator"
          description="Aufstellungen anzeigen"
          icon={<IconMicrophone size={24} />}
          color="violet"
          to="commentator"
        />
        <QuickLink
          title="Commands"
          description="Zentrale Steuerung"
          icon={<IconCommand size={24} />}
          color="orange"
          to="command"
        />
        <QuickLink
          title="Grafiken"
          description="Stream-Overlays"
          icon={<IconStackFront size={24} />}
          color="dark"
          to="streamelements"
        />
        <QuickLink
          title="Werbung"
          description="Sponsoren verwalten"
          icon={<IconMoneybag size={24} />}
          color="grape"
          to="ads"
        />
      </SimpleGrid>
    </Page>
  );
};
